import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
  { name: 'Home', path: '/' },
  { name: 'About', path: '/about' },
  { name: 'Our Products & Services', path: '/products' },
  { name: 'Join the EWC', path: '/join-ewc' },
  { name: 'Contact', path: '/contact' }];


  const isActive = (path) => location.pathname === path;

  return (
    <header className="header-nav">
      <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', maxWidth: '1280px', margin: '0 auto' }}>
        <Link to="/" style={{ textDecoration: 'none', color: 'var(--text-primary)', flexShrink: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
            <img
              src="https://customer-assets.emergentagent.com/job_4c223b67-9c3e-4e9b-9f63-72b14bc072ff/artifacts/swml20qc_Maroon%20%26%20Beige%20Modern%20Restaurant%20Menu%20Menu%20Portrait%20%282%20Page%29.png"
              alt="The VEC Logo"
              style={{ height: '50px', width: 'auto' }} className="!mx-[1px] logo-img" />
            <span style={{ fontSize: '1.25rem', fontWeight: '700', letterSpacing: '-0.01em', whiteSpace: 'nowrap' }} className="logo-text">
              The Vision Execution Co.
            </span>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <nav style={{ display: 'none' }} className="desktop-nav">
          <ul style={{ display: 'flex', gap: '1.75rem', listStyle: 'none', margin: 0, padding: 0 }}>
            {navigation.map((item) =>
            <li key={item.name}>
                <Link
                to={item.path}
                style={{
                  textDecoration: 'none',
                  color: isActive(item.path) ? 'var(--text-primary)' : 'var(--text-secondary)',
                  fontSize: '0.875rem',
                  fontWeight: isActive(item.path) ? '500' : '400',
                  whiteSpace: 'nowrap',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => e.target.style.color = 'var(--text-primary)'}
                onMouseLeave={(e) => e.target.style.color = isActive(item.path) ? 'var(--text-primary)' : 'var(--text-secondary)'}>

                  {item.name}
                </Link>
              </li>
            )}
          </ul>
        </nav>

        <div style={{ display: 'none' }} className="desktop-cta">
          <Link to="/contact" className="btn-primary" style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>
            Book a Consultation
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="mobile-menu-btn"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            flexShrink: 0,
            marginLeft: '0.5rem',
            color: 'var(--text-primary)'
          }}>

          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen &&
      <div
        className="mobile-menu"
        style={{
          position: 'absolute',
          top: '80px',
          left: 0,
          right: 0,
          background: 'var(--bg-overlay)',
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
          borderTop: '1px solid var(--border-light)',
          padding: '1.5rem'
        }}>

          <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: '1rem' }}>
            {navigation.map((item) =>
          <li key={item.name}>
                <Link
              to={item.path}
              onClick={() => setIsMenuOpen(false)}
              style={{
                textDecoration: 'none',
                color: isActive(item.path) ? 'var(--text-primary)' : 'var(--text-secondary)',
                fontSize: '1rem',
                fontWeight: isActive(item.path) ? '500' : '400',
                display: 'block',
                padding: '0.5rem 0'
              }}>

                  {item.name}
                </Link>
              </li>
          )}
          </ul>
          <Link to="/contact" className="btn-primary" style={{ marginTop: '1.5rem', width: '100%' }} onClick={() => setIsMenuOpen(false)}>
            Book a Consultation
          </Link>
        </div>
      }

      <style>{`
        @media (max-width: 480px) {
          .logo-text {
            font-size: 1rem !important;
          }
          .logo-img {
            height: 38px !important;
          }
        }
        @media (max-width: 360px) {
          .logo-text {
            font-size: 0.875rem !important;
          }
        }
        @media (min-width: 1024px) {
          .desktop-nav {
            display: block !important;
          }
          .desktop-cta {
            display: block !important;
          }
          .mobile-menu-btn {
            display: none !important;
          }
        }
      `}</style>
    </header>);

};

export default Header;